import { render, staticRenderFns } from "./StageChange.vue?vue&type=template&id=c37aa384&"
import script from "./StageChange.vue?vue&type=script&lang=ts&"
export * from "./StageChange.vue?vue&type=script&lang=ts&"
import style0 from "./StageChange.vue?vue&type=style&index=0&id=c37aa384&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports